import { StyleProp, ViewStyle } from 'react-native';

import IconNoItem from '../../assets/svg/IconNoItem';
import { NotFoundSubtitle } from '../../components/SearchResultPage/EmptyResult/EmptyResultHeader';
import { translate } from '../../i18n';
import Touchable from '../Touchable';
import { S } from './styles';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  text?: string;
  actionBtnText?: string;
  useActionBtn?: boolean;
  imageColor?: string;
  textColor?: string;
  actionBtnTextColor?: string;
  onActionBtnPress?: () => void;
  actionBtnWebProps?: object;
  shouldRenderFilterEmptyResult?: boolean;
}

const hitSlop = { top: 10, right: 10, bottom: 10, left: 10 };

export default function NoMoreItemsView(props: Props) {
  const {
    containerStyle,
    text,
    useActionBtn,
    imageColor,
    textColor,
    shouldRenderFilterEmptyResult,
  } = props;

  const onPress = () => {
    const { onActionBtnPress } = props;

    if (typeof onActionBtnPress === 'function') {
      onActionBtnPress();
    }
  };

  const renderActionBtn = () => {
    const { actionBtnText, actionBtnTextColor, actionBtnWebProps } = props;

    return (
      <Touchable
        onPress={onPress}
        hitSlop={hitSlop}
        testID="actionBtn"
        {...actionBtnWebProps}
      >
        <S.ActionBtnText color={actionBtnTextColor}>
          {actionBtnText}
        </S.ActionBtnText>
      </Touchable>
    );
  };

  if (shouldRenderFilterEmptyResult) {
    return (
      <S.Container testID="filterEmptyResult">
        <S.EmptyResultImage
          source={require('../../components/SearchResultPage//assets/empty_search.png')}
        />
        <S.EmptyResultTitle>
          {translate('SearchNotFoundTitle')}
        </S.EmptyResultTitle>
        <NotFoundSubtitle />
      </S.Container>
    );
  }

  return (
    <S.Container style={containerStyle}>
      <IconNoItem fillColor={imageColor} />
      <S.NoMoreItemsText color={textColor}>
        {text || translate('noMoreItems')}
      </S.NoMoreItemsText>
      {useActionBtn && renderActionBtn()}
    </S.Container>
  );
}

NoMoreItemsView.defaultProps = {
  useActionBtn: false,
};
